<template>
    <div class="assembleLeft_statistics" ref="statistics">
        <div class="assembleLeft_statistics_scroll" :style="{'height': left_fixed ? boxHeight + 'px' : 'auto'}">
            <div class="assembleLeft_title">
                <b>试题统计调整</b>
                <span></span>
            </div>
            <div class="assembleLeft_statistics_number">
                <label>分数：{{totalScore}}分</label>
                <label>题数：{{totalQuestion}}</label>
            </div>
            <!-- 题组 -->
            <div class="assembleLeft_statistics_group" v-for="(item,index) in segment_list" :key="item.name">
                <!-- 题组拖拽区 -->
                <div 
                    class="assembleLeft_statistics_group_drag" 
                    draggable="true"
                    @dragstart="boxDragStart($event,item,index)"
                    @dragend="boxDragEnd($event)"
                    @click="boxDragClick(item,index)"
                    :class="{on:index==currentNode[0]&&currentNode.length == 1}"
                >
                    <div class="assembleLeft_statistics_group_up">
                        <b :title="item.name">{{getChineseNumber(index)}}.{{item.name}}</b>
                        <i v-html="getStructSegmentmemo(index)"></i>
                        <span class="iconfont icon-shanchu" @click="delQuestion(index)"></span>
                        <span class="iconfont icon-zhuanyi" v-if="transferIcon(item)" @click="transferTest(index)"></span>
                        <slot name="leftGroupButtons" :data="item" :index="index"></slot>
                    </div>
                    <leftBoxGroup class="assembleLeft_statistics_group_down" :item="item" :index="index"  @toScroll="$emit('toScroll')"></leftBoxGroup>
                </div>
                <!-- 拖拽接收容器 -->
                <div class="assembleLeft_statistics_group_drop"
                    v-if="boxDragEnter"
                    @drop="boxDrop($event,item,index)"
                    @dragover="allDrag($event)"
                    @dragenter="boxDragHover($event,item,index,1)"
                    @dragleave="boxDragHover($event,item,index,0)"
                ></div>
            </div>
            <div class="assembleLeft_statistics_operate">
                <el-button plain @click="addGroup">添加自定义组</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import leftBoxGroup from './leftBoxGroup'//组小题
import utils from './utils';
import $store from '../store'
export default {
    props:['left_fixed'],
    data(){
        return{
            boxDragEnter:false,//正在拖拽
            boxHeight: document.documentElement.clientHeight,//内容区高度
            hoverIndex:'',
        }
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        currentNode(){
            return $store.state.currentNode
        },
        segment_list(){
            return $store.state.segment_list
        },
        totalQuestion(){
            return $store.getters.totalQuestion
        },
        totalScore(){//总分
            let total = 0
            let list = this.assemblyData.segment_list
            list.forEach(one => {
                one.questions.forEach(two=>{
                    if(two.question_list){
                        two.question_list.forEach(three=>{
                            total = utils.formatNum(total+Number(three.test_score),2)
                        })
                    }else{
                        total = utils.formatNum(total+Number(two.test_score),2)
                    }
                })
            });
            return total
        }
    },
    methods: {
        getChineseNumber(index){//对应中文数字
            return utils.getChineseNumber(index+1)
        },
        boxDrop(e,item,index){
            e.target.style = ''
            $store.commit('MOVEASSEMBLYNODE',[index])
            this.$nextTick(function () {
                this.$emit('toScroll')
            })
        },
        allDrag(e){
            e.preventDefault();
            e.stopPropagation();
        },
        boxDragStart(e,item,index){
            e.dataTransfer.setData('aaa', '')
            let data = [index]
            $store.commit('SETSELECTEDNODE',data)
            this.boxDragEnter = true
        },
        boxDragEnd(){
            this.boxDragEnter = false
        },
        boxDragHover(e,item,index,type){
            if(type == 1){
                e.target.style.border = '1px dashed #5A75F6'
            }else{
                e.target.style = ''
            }
        },
        boxDragClick(item,index){
            let data = [index]
            $store.commit('SETSELECTEDNODE',data)
            this.$emit('toScroll')
        },
        delQuestion(index){//删除组
            let data = [index]
            $store.commit('SETSELECTEDNODE',data)
            this.$msgBox.delDialog('确认删除该大题么',()=>{
                $store.commit('DELASSEMBLEQUESTION',()=>this.$emit('delEmpty'))
            })
        },
        transferTest(index){//转移试题
            let data = [index]
            $store.commit('SETSELECTEDNODE',data)
            $store.commit('SETTRANSFERTESTSHOW')
        },
        addQuestionsTransfer(index,num){
            let data = index+'-'+num
            let i = this.transferList.indexOf(data)
            if(i > -1){
                this.transferList.splice(i,1)
            }else{
                this.transferList.push(data)
            }
        },
        addGroup(){//添加组
            if(this.assemblyData.segment_list.length >= 10){
                this.$msgBox.alert('最多添加十个组')
                return
            }
            this.$prompt('请输入自定义组名称', '添加自定义组', {
                inputPattern:/^\S{1,30}$/,
                inputErrorMessage:'请输入自定义组名称，长度30个字符以内',
                customClass:'message_prompt',
                showCancelButton:false
            })
            .then((val)=>{
                let state = this.assemblyData.segment_list.some(el=>{
                    if(el.name == val.value){
                        this.$msgBox.alert('已有该名称的题组，请添加其他名称！')
                        return true
                    }
                })
                if(!state){
                    $store.commit('ADDASSEMBLEGROUP',val.value)
                }
            }).catch(()=>{})
        },
        getStructSegmentmemo(index){//获得组总分
            let score = 0
            let group = this.assemblyData.segment_list[index].questions
            group.forEach(one => {
                if(one.material_id){
                    one.question_list.forEach(two=>{
                        // score += Number(two.test_score)
                        score = utils.formatNum(score+Number(two.test_score),2)
                    })
                }else{
                    score = utils.formatNum(score+Number(one.test_score),2)
                }
            });
            return `（${score}分）`
        },
        setHeight(){
            let el = this.$refs.statistics
            let list = el.parentNode.children
            let high = 300
            for(let i = 0; i<list.length; i++){
                if(list[i] != el){
                    high += list[i].clientHeight
                }
            }
            this.boxHeight = document.documentElement.clientHeight - high
        },
        transferIcon(item){
            let i = 0
            item.questions.forEach(el=>{
                if(el.question_list){
                    i += el.question_list.length
                }else{
                    i++
                }
            })
            return i != this.totalQuestion
        },
        // addQuestion(index){
        //     this.$prompt('请输入试题id用”,“隔开', '添加试题', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         inputPattern: /^[0-9,]*$/,
        //         inputErrorMessage: '试题id格式不正确'
        //         }).then(({ value }) => {
        //             this.$emit('add-question',value)
        //         })
        // }
    },
    components: {
        leftBoxGroup
    },
    mounted () {
        // this.$nextTick(()=>{
            this.setHeight()
        // })
        window.onresize = () => {
            this.setHeight()
        }
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-assembly/src/leftStatistics.vue